import { AppModule } from '@app/types';
import { LoggerIcon } from '../LoggerIcon';

export const LoggerModule: AppModule = {
  id: 'logger',
  icon: <LoggerIcon />,
  title: 'Logger',
  basePath: 'logger',
};
